import CustomTable from '../../../../../components/table/CustomTable';
import { permissionObj } from '../../../../../Helpers/permission';
import React from 'react';
import AllEmployeesTableApp from '../Functionality/AllEmployeesTableApp';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import { getViewTypeByName } from '../../../../../enums/ViewType';
import DisplayView from '../../../../../components/DisplayView';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AllEmployeesTable = (props) => {

    const {
        contractorId,
        supplierId,
        isAllChecked,
        setIsAllChecked,
        setSearch,
        setSimpleSearch,
        searchElement,
        setSearchElement,
        selectedList,
        setSelectedList,
        view,
        option,
        setBodyForExport,
        goCreate,
        setExpandImage,
        modified,
        setModified,
        finalArray,
        criteria,
        setCriteria,
        handleView,
        showActionsContractorSupplier
    } = props;

    const {
        setSearchResults,
        DEV,
        permission,
        tableId,
        searchId,
        t, thead, tbody, handleCheckboxChange, handleDeleteAll,
        pagination, page, rowsPerPage,
        getActionsButtons,
        deletePermission
    } = AllEmployeesTableApp({
        contractorId,
        supplierId,
        setIsAllChecked,
        setSimpleSearch,
        searchElement,
        selectedList,
        setSelectedList,

        setExpandImage,
        modified,
        setModified,

        finalArray,
        view,
        criteria,
        setCriteria,
        option,
        setBodyForExport,
        showActionsContractorSupplier
    });

    return (
        <>
            <div className="d-flex">
                <DisplayView view={view} setView={(view) => handleView(view)} left={0} />
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={"txt_aet_search_simple"}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={(contractorId || supplierId || DEV
                    || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)
                    || permission?.includes(permissionObj?.WEB_EMPLOYEE_READ))}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                childrenNotInformation={
                    tbody?.data?.length === 0 ?
                        <>
                            <div className={"warning-text"}>
                                <p>{t("you_haven_not_created_any_employee")}</p>
                            </div>
                            {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_CREATE)) &&
                                <CustomButtonLink
                                    splitName={false}
                                    id={'btn_aet_create'}
                                    card={true}
                                    onClick={() => {
                                        goCreate();
                                    }}
                                    name={'create_new_employee'}
                                />
                            }
                        </>
                        : undefined
                }
            />
            {pagination()}
        </>
    );
}

export default AllEmployeesTable
